type TRandomStringOptions = {
  mustStartWithLetter?: boolean;
};

const randomString = (length: number, options?: TRandomStringOptions) => {
  // id's must start with letter, so just going to default this to true because we mostly use this for ids
  const { mustStartWithLetter = true } = options || {};
  const alphabet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

  let random = '';
  while (random.length < length) {
    random += randomStringSegment();
  }

  random = random.substring(0, length);

  if (mustStartWithLetter) {
    const firstChar = alphabet.charAt(Math.floor(Math.random() * alphabet.length));
    return firstChar + random.substring(1);
  }

  return random;
};

const randomStringSegment = () => {
  return Math.random().toString(36).substring(2);
};

export default randomString;
